import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Survey\UpdateSurveyController::__invoke
* @see app/Http/Controllers/Survey/UpdateSurveyController.php
* @route '/api/survey/{survey}'
*/
const UpdateSurveyController = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSurveyController.url(args, options),
    method: 'put',
})

UpdateSurveyController.definition = {
    methods: ["put"],
    url: '/api/survey/{survey}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Survey\UpdateSurveyController::__invoke
* @see app/Http/Controllers/Survey/UpdateSurveyController.php
* @route '/api/survey/{survey}'
*/
UpdateSurveyController.url = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { survey: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { survey: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            survey: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        survey: typeof args.survey === 'object'
        ? args.survey.id
        : args.survey,
    }

    return UpdateSurveyController.definition.url
            .replace('{survey}', parsedArgs.survey.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Survey\UpdateSurveyController::__invoke
* @see app/Http/Controllers/Survey/UpdateSurveyController.php
* @route '/api/survey/{survey}'
*/
UpdateSurveyController.put = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateSurveyController.url(args, options),
    method: 'put',
})

export default UpdateSurveyController